import { useEffect, useState } from "react";
import { useInView } from "../lib/useInView";

export const AnimatedCounter = ({ value, prefix = "", suffix = "", duration = 1800, className = "" }) => {
    const [ref, inView] = useInView();
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!inView) return;
        if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            setCount(value);
            return;
        }
        let start = 0;
        const end = value;
        const startTime = performance.now();
        let raf;
        const tick = (now) => {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            // ease-out cubic
            const eased = 1 - Math.pow(1 - progress, 3);
            const current = Math.floor(start + (end - start) * eased);
            setCount(current);
            if (progress < 1) raf = requestAnimationFrame(tick);
            else setCount(end);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [inView, value, duration]);

    const formatted = count >= 1000 ? count.toLocaleString() : count.toString();

    return (
        <span ref={ref} className={className} data-testid="animated-counter">
            {prefix}
            {formatted}
            {suffix}
        </span>
    );
};

export default AnimatedCounter;
